import { Component } from '@angular/core';
import { Events, NavController } from 'ionic-angular';

import { Api } from '../../providers/api/api';
import { Utils } from '../../providers/utils/utils';
import { IPTV } from '../../providers/iptv/iptv';

import { Channel }     from '../../pages/channel/channel';
import { Application } from '../../pages/application/application';

/*
*
*  Categories Page
*
*/
@Component({
  selector: 'categories',
  templateUrl: 'categories.html'
})
export class Categories {

    public categories : any = [];
    public empty : boolean = false;
    
    constructor( 
        private navCtrl: NavController,  
        public events: Events, 
        public utils: Utils,
        public IPTV: IPTV,
        private api : Api
    ) {
        this.events.subscribe('app:refresh', (params : any = {}) => { 
            this.init(true, true);
        });

        this.events.subscribe('source:update', (params : any = {}) => { 
            this.init(true);
        });
    }

    ionViewWillEnter(){
    }
  
    ionViewDidLoad() {  
        this.init();
    }

    doRefresh(refresher) {

        this.getCategories(true).then((data:any=[]) => {
            if (data.length ) {
                this.categories = data;
                this.empty = false;
            } else {
                this.categories = [];
                this.empty = true;
            }
            
            refresher.complete();
        }, (err) => {
           refresher.complete();
            this.utils.error(err);
        });

    }
    

    init (noLoad:boolean=false, writeCache:boolean=false) {
        if (!noLoad) this.utils.load();
        
        this.getCategories(writeCache).then((data:any=[]) => {

            if (data.length ) {
                this.categories = data;
                this.empty = false;
            } else {
                this.categories = [];
                this.empty = true;
            }

            if (!noLoad) this.utils.unload();
        });
    }
    
    getCategories(writeCache:boolean=false) {
        
        return new Promise((resolve, reject) => {
            this.api.getCached('/iptv/category?idBox='+this.IPTV.boxID, { writeCache:writeCache }).subscribe((response:any)=>{
                resolve(response.result.result);
            },(err) => {
                reject(this.api.reject(err));
            });
       });
    }

    goToCategories(category) {
        this.events.publish('app:searchClose');
        this.navCtrl.push(Channel, category);
    }

    goToApplications() {
        this.events.publish('app:searchClose');
        this.navCtrl.push(Application);
    }

    
}



// WEBPACK FOOTER //
// ./src/pages/categories/categories.ts